<template>
  <div class="login container">

    <div v-if="!sellCardPermission()" class="pt-5">
      <h2>Sorry, you do not have permissions to access this feature.</h2>
    </div>

    <form v-else @submit.prevent="submit" class="d-flex justify-content-center flex-column align-items-center">

      <div class="d-flex justify-content-between w-100">
      
        <div class="col-xs-6 pl-3 pt-5">
          <cta link="payment" shape="circle" icon="left-arrow" text="" margin="no-margin" />
        </div>
        <div class="col-xs-6  pr-3 pt-5">
          <cta type="submit" shape="circle" text="" icon="right-arrow" :disabled="reason == ''" margin="no-margin" :loading="submitted" />
        </div>
        </div>
      
        <div class="row">
          <h2 class="col-md-12 pt-2 pb-3">Reason for issuing a free of charge card</h2>
        </div>


        <div class="row text-input-holder">
            <textarea class="d-flex justify-content-center" v-model="reason" placeholder="Reason goes here" name="reason" v-validate="'required'" ></textarea>
        </div>
        

    </form>
   
  </div>
</template>

<script>
export default {
  name: 'Login',
  inject: ['$validator'],
  data : function(){       
      return {
        submitted : false,
        reason    : '',
      };
  },
  created:function(){

  },
  computed: {

    orderPayload(){
      return this.$store.getters.getOrderPayload;
    },

    account(){
      return this.$store.getters.getAccount;
    }

  },
  watch:{

    
    
  },
  mounted: function(){

  },
  methods:{

    takePayment() {
        this.paymentConfirm = true;
    },

    submit() {
        this.$set(this.orderPayload, 'note', this.reason);
        this.$set(this.orderPayload, 'payment', 'foc');
        this.$store.commit("ORDER_PAYLOAD",this.orderPayload);

        if(this.orderPayload.digitalJourney) {
            this.$router.push({ name: 'receipt'});
        }

        if(this.orderPayload.physicalJourney) {
            if(this.account.auto_generate_card_references)
                this.$router.push({ name: 'receipt'});
            else
                this.$router.push({ name: 'gift-unique-code'});
        }

    }
    
  }
}
</script>

<style scoped>

  .select-holder {
    margin-top: 15px;
  }

</style>
